import React, { Component } from 'react'
import Icon from 'components/shared/Icon'
import { toast } from 'react-toastify'
import notificationToast from 'helpers/notificationToast'
import InfoIcon from '@material-ui/icons/Info'
import { includes } from 'libraries/lodash'
import cx from 'classnames'

export default class Icons extends Component {
  state = { search: '' }

  render () {
    const icons = (process.env.ICONS || []).filter(i => this.state.search ? includes(i, this.state.search) : true).map(i => i.replace('src/icons/', 'icon-').replace('.svg', ''))
    return (
      <div className='utils-view'>
        <section className='bot-border-black section-heading'>
          Developer utils
        </section>
        <h3>Available icons <small>(click on icon to copy it&apos;s class name)</small></h3>
        <div>
          Filter: <input type='text' value={this.state.search} onChange={({ target: { value: search } }) => { this.setState({ search }) }} />
        </div>
        <div className='icons'>
          {icons.map((className, key) => <IconButton key={key} {...{ className }} />)}
        </div>
      </div>
    )
  }
}

const IconButton = ({ className }) => (
  <button
    className='icon btn pointer'
    title={className}
    data-clipboard-text={className}
    onClick={() => notificationToast(<InfoIcon />, toast.TYPE.INFO, className)}
  >
    <Icon name={className} className={cx('w6', className)} />
    <br />
    <small style={{ fontSize: 9 }}>{className.replace(/^icon-/, '')}</small>
  </button>
)
